import { h, Host } from "@stencil/core";
const baseClass = "ux-checkbox-rules";
const requireAttr = "data-ux-checkbox-rules-require";
export class CheckboxRules {
    element;
    checkboxRules = [];
    getCheckboxRuleByName = (name) => {
        return this.checkboxRules.filter((rule) => rule.name === name)[0];
    };
    getCheckboxByName = (name) => {
        return this.element.querySelector(`ux-checkbox[name=${name}]`);
    };
    handleCheckboxChanges(e) {
        // Does not work with nested required rules
        const checkbox = e.target;
        const checkboxRule = this.getCheckboxRuleByName(checkbox.name);
        const otherCheckboxRules = this.checkboxRules.filter((rule) => rule !== checkboxRule);
        checkboxRule.checked = checkbox.checked;
        if (checkbox.checked) {
            const activated = [];
            checkboxRule.required.forEach((checkboxName) => {
                const requiredCheckboxRule = this.getCheckboxRuleByName(checkboxName);
                const requiredCheckbox = this.getCheckboxByName(checkboxName);
                if (!requiredCheckbox.checked) {
                    activated.push(checkboxName);
                }
                requiredCheckboxRule.checked = true;
                requiredCheckbox.checked = true;
                checkboxRule.activated = activated;
            });
        }
        else {
            checkboxRule.activated.forEach((checkboxName) => {
                const activatedCheckbox = this.getCheckboxByName(checkboxName);
                activatedCheckbox.checked = false;
            });
            checkboxRule.activated = [];
            // Check if current checkbox is required on other rules
            otherCheckboxRules.forEach((otherRule) => {
                if (otherRule.required.includes(checkbox.name)) {
                    otherRule.activated.forEach((checkboxName) => {
                        const activatedCheckbox = this.getCheckboxByName(checkboxName);
                        activatedCheckbox.checked = false;
                    });
                    otherRule.activated = [];
                    otherRule.checked = false;
                    this.getCheckboxByName(otherRule.name).checked = false;
                }
            });
        }
    }
    initCheckboxes = () => {
        this.checkboxRules = Array.from(this.element.querySelectorAll("ux-checkbox")).map((element) => {
            return {
                name: element.name,
                checked: element.checked,
                // @ts-expect-error Check for typing
                required: element.hasAttribute(requireAttr) ? element.getAttribute(requireAttr).split(",") : [],
                activated: []
            };
        });
    };
    componentDidLoad() {
        this.initCheckboxes();
    }
    render() {
        return (h(Host, { key: 'b1258d744c9c70cc7712022761bdbe2603ae64b0', class: {
                [baseClass]: true
            } }, h("slot", { key: '40c1924380522d2ab94416138375b7aa4f8934bc' })));
    }
    static get is() { return "ux-checkbox-rules"; }
    static get elementRef() { return "element"; }
    static get listeners() {
        return [{
                "name": "uxCheckboxChange",
                "method": "handleCheckboxChanges",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=checkbox-rules.js.map
